import { isValid } from 'date-fns';
import PT from 'prop-types';

const parsableDate = (props, propName, componentName) => {
  const date = props[propName];

  if (date === undefined) {
    return null;
  }

  if (!isValid(new Date(date))) {
    return new Error(
      `Invalid prop \`${propName}\` supplied to \`${componentName}\`. Must be a valid Date-Time String Format`
    );
  }
};
parsableDate.isRequired = PT.string.isRequired;

export { parsableDate };
